export interface ISeasonAccessCostEntry {
    timestamp: number;
    cost: number;
    current: boolean;
}

export function getSeasonAccessCostEntries(value: any, now: number = Date.now()): ISeasonAccessCostEntry[] {
    if (typeof value === 'number') {
        return [{ timestamp: 0, cost: value, current: true }];
    }

    if (!value || typeof value !== 'object') {
        return [];
    }

    const entries = Object.keys(value)
        .map(timestamp => ({
            timestamp: Number(timestamp),
            cost: Number(value[timestamp]),
            current: false
        }))
        .filter(entry => isFinite(entry.timestamp) && isFinite(entry.cost))
        .sort((a, b) => a.timestamp - b.timestamp);

    if (!entries.length) {
        return [];
    }

    let currentIndex = 0;
    entries.forEach((entry, index) => {
        if (entry.timestamp * 1000 <= now) {
            currentIndex = index;
        }
    });

    entries[currentIndex].current = true;
    return entries;
}

export function getSeasonAccessCost(value: any, now: number = Date.now()): number {
    const current = getSeasonAccessCostEntries(value, now).find(entry => entry.current);
    return current ? current.cost : 0;
}
